module.exports = __webpack_public_path__ + "img/icone_icone_6.2b0f8287.svg";